import { createContext } from 'react'

import { VAT_STATUS } from '../price-context/VAT_STATUS'

export interface IVatStatusContext {
  vatStatus: VAT_STATUS
  setVatStatus: React.Dispatch<React.SetStateAction<VAT_STATUS>>
}

export const VatStatusContext = createContext<IVatStatusContext>({
  vatStatus: VAT_STATUS.HT,
  setVatStatus: () => undefined,
})
